<template>
  <div class="renshiindex">
    <div class="flex bigbox w1200">
      <el-tabs class="contbox" v-model="nav_ac" type="border-card" tab-position="left" @tab-click="tabChange" ref="tab">
        <el-tab-pane label="人事服务">
          <div class="datainfo">
            <div class="nav-banner flex">
              <div class="bannerbox">
                <el-carousel height="100%">
                  <el-carousel-item v-for="(x,i) in list_nav0.bannerData" :key="i">
                    <el-image class="bannerImg" :src="x.imgUrl|toimg" @click="openUrl(x.clickUrl)"></el-image>
                  </el-carousel-item> 
                </el-carousel>
              </div>
              <div class="showDatabox">
                <ul class="flex cataloglist">
                  <li
                    v-for="(x1,i1) in list_nav0.listData" :key="i1"
                    class="nav_sub" :class="{'active':nav_sub_ac===i1}" 
                    @mouseover="nav_sub_ac=i1" @click="navToRsrc(x1.key)">{{x1.name}}</li>
                </ul>
                <ul class="articleul">
                  <li
                    v-for="(x1,i1) in list_nav0.listData[nav_sub_ac].data" :key="i1"
                    class="articlelist flex" @click="navToRsrcDetail(x1)">
                    <span class="dian"></span>
                    <span class="titlespan">{{x1.title}}</span>
                    <span class="timespan">[{{x1.createTime}}]</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="人才超市">
          <div class="datainfo">
            <div class="nav-normal flex flex-l part-rccs">
              <div class="renshicont" v-for="(x1,i1) in list_nav1.listData" :key="i1">
                <ul>
                  <li class="listcatalog">
                    <span class="name nav_sub" @click="navToRsrc(x1.key)">{{x1.name}}</span>
                    <span class="more" @click="navToRsrc(x1.key)">+更多</span>
                  </li>
                  <li
                    v-for="(x2,i2) in x1.data"
                    class="list" :key="i2" @click="navToRsrcDetail(x2)" >
                    <span class="titlespan">{{x2.title}}</span>
                    <span class="timespan">[{{x2.createTime}}]</span>
                  </li>
                </ul>
              </div>
              <div class="renshicont btn-box flex">
                <div class="btn flex" @click="navToRsrc('caishizhaopin')">
                  <el-image style="width:68px; height:68px" :src="icons[0]" fit="fill"></el-image>
                  <p>才市招聘</p>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="就业服务">
          <div class="datainfo">
            <div class="nav-normal flex flex-l">
              <div class="renshicont" v-for="(x1,i1) in list_nav2.listData" :key="i1">
                <ul>
                  <li class="listcatalog">
                    <span class="name nav_sub" @click="navTo3g48(x1.key)">{{x1.name}}</span>
                    <span class="more" @click="navTo3g48(x1.key)">+更多</span>
                  </li>
                  <li
                    v-for="(x2,i2) in x1.data" :key="i2"
                    class="list" @click="navTo3g48Detail(x1.key,x2)" >
                    <span class="titlespan">{{x2.name||x2.jobName}}</span>
                    <span class="timespan">[{{x2.createTime}}]</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="创业服务">
          <div class="datainfo">
            <div class="nav-normal flex flex-l">
              <div class="renshicont" v-for="(x1,i1) in list_nav3.listData" :key="i1">
                <ul>
                  <li class="listcatalog">
                    <span class="name nav_sub" @click="navTo3g48(x1.key)">{{x1.name}}</span>
                    <span class="more" @click="navTo3g48(x1.key)">+更多</span>
                  </li>
                  <li
                    v-for="(x2,i2) in x1.data" :key="i2"
                    class="list" @click="navTo3g48Detail(x1.key,x2)" >
                    <span class="titlespan">{{x2.name}}</span>
                    <span class="timespan">[{{x2.createTime}}]</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="法律服务">
          <div class="datainfo">
            <div class="nav-normal flex flex-h">
              <div
                v-for="(x1,i1) in list_nav5.iconData" :key="i1"
                class="icon-btn" @click="navTo('lvshi', x1.label)">
                <el-image style="width: 83px; height: 83px" :src="x1.icon" fit="fill"></el-image>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="综合服务">
          <div class="datainfo">
            <div class="nav-normal flex flex-h">
              <div class="icon-btn icon-btn1 flex" v-for="(x1,i1) in list_nav4.iconData" :key="i1" @click="navTo(x1.key)">
                <el-image style="width: 51px; height: 51px" :src="x1.icon" fit="fill"></el-image>
                <p>{{x1.label}}</p>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="互动交流">
          <div class="datainfo">
            <div class="nav-normal flex flex-l part-hdjl">
              <div class="renshicont" v-for="(x1,i1) in list_nav6.listData" :key="i1">
                <ul>
                  <li class="listcatalog">
                    <span class="name nav_sub" @click="navToRsrc(x1.key)">{{x1.name}}</span>
                    <span class="more" @click="navToRsrc(x1.key)">+更多</span>
                  </li>
                  <li
                    v-for="(x2,i2) in x1.data" :key="i2"
                    class="list" @click="navToRsrcDetail(x2)">
                    <span class="titlespan">{{x2.title}}</span>
                    <span class="timespan">[{{x2.createTime}}]</span>
                  </li>
                </ul>
              </div>
              <div class="renshicont btn-box flex">
                <div class="btn flex" @click="navToRsrc('leaderBox')">
                  <el-image style="width:68px; height:68px" :src="icons[4]" fit="fill"></el-image>
                  <p>领导信箱</p>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="新闻中心">
          <div class="datainfo">
            <div class="nav-banner flex">
              <div class="bannerbox">
                <el-carousel height="100%">
                  <el-carousel-item v-for="(x,i) in list_nav7.bannerData" :key="i">
                    <el-image class="bannerImg" :src="x.imgUrl|toimg" @click="openUrl(x.clickUrl)"></el-image>
                  </el-carousel-item> 
                </el-carousel>
              </div>
              <div class="showDatabox">
                <ul class="flex cataloglist">
                  <li
                    v-for="(x1,i1) in list_nav7.listData" :key="i1"
                    class="nav_sub active"
                    @click="navToRsrc(x1.key)">{{x1.name}}</li>
                </ul>
                <ul class="articleul">
                  <li
                    v-for="(x1,i1) in list_nav7.listData[0].data" :key="i1"
                    class="articlelist flex" @click="navToRsrcDetail(x1)">
                    <span class="dian"></span>
                    <span class="titlespan">{{x1.title}}</span>
                    <span class="timespan">[{{x1.createTime}}]</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="flex outBox w1200">
      <div class="outBtn" v-for="(x,i) in siteNavs_x" :key="i" @click="navToOut(x.url)">{{x.name}}</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  data() {
    return {
      nav_ac: '0',
      nav_sub_ac: 0,

      icons: [
        require('@/views/showpage/images/rsrc/rccs_1.png'),
        require('@/views/showpage/images/rsrc/rccs_2.png'),
        require('@/views/showpage/images/rsrc/rccs_3.png'),
        require('@/views/showpage/images/rsrc/rccs_4.png'),
        require('@/views/showpage/images/rsrc/rccs_5.png'),
        require('@/views/showpage/images/rsrc/rccs_6.png'),
      ],

      list_nav0: {
        bannerData: [],
        listData:[
          {name:'人事招考',key:'examination',num:11,data:[]},
          {name:'人事档案',key:'archives',num:11,data:[]},
          {name:'人事信息',key:'information',num:11,data:[]},
          {name:'人事培训',key:'train',num:11,data:[]},
        ],
      },
      list_nav1: {
        bannerData: [],
        listData: [
          {name:'才市预告',key:'notice',num:7,data:[]},
          {name:'现场招聘',key:'scene',num:4,data:[]},
          {name:'视频招聘',key:'video',num:4,data:[]},
        ]
      },
      list_nav2: {
        bannerData: [],
        listData: [
          {name:'招聘',key:'zhaopin',num:4,data:[]},
          {name:'求职',key:'qiuzhi',num:4,data:[]},
          {name:'教育',key:'jiaoyu',num:4,data:[]},
          {name:'培训',key:'peixun',num:4,data:[]},
        ]
      },
      list_nav3: {
        bannerData: [],
        listData: [
          {name:'融资',key:'rongzi',num:4,data:[]},
          {name:'投资',key:'touzi',num:4,data:[]},
          {name:'招商',key:'zhaoshang',num:4,data:[]},
          {name:'加盟',key:'jiameng',num:4,data:[]},
        ]
      },
      list_nav4: {
        iconData: [
          {label:'专家服务',key:'out',icon:require('../images/rsrc/zhfw_3.png')},
          {label:'人才导师',key:'out',icon:require('../images/rsrc/zhfw_1.png')},
          {label:'创业导师',key:'out',icon:require('../images/rsrc/zhfw_2.png')},
          {label:'培训招生',key:'peixun',icon:require('../images/rsrc/zhfw_12.png')},
          {label:'租房服务',key:'zufang',icon:require('../images/rsrc/zhfw_4.png')},
          {label:'售房服务',key:'shoufang',icon:require('../images/rsrc/zhfw_5.png')},
          {label:'汽车服务',key:'qiche',icon:require('../images/rsrc/zhfw_6.png')},
          {label:'电商服务',key:'gouwu',icon:require('../images/rsrc/zhfw_7.png')},
          {label:'美食服务',key:'meishi',icon:require('../images/rsrc/zhfw_8.png')},
          {label:'旅游服务',key:'lvyou',icon:require('../images/rsrc/zhfw_9.png')},
          {label:'健康服务',key:'jiankang',icon:require('../images/rsrc/zhfw_10.png')},
          {label:'更多服务',key:'out',icon:require('../images/rsrc/zhfw_11.png')},
        ],
      },
      list_nav5: {
        iconData: [
          {label:'求助',key:'qiuzhi',icon:require('../images/rsrc/flfw_01.png')},
          {label:'民事',key:'minshi',icon:require('../images/rsrc/flfw_03.png')},
          {label:'刑事',key:'xingshi',icon:require('../images/rsrc/flfw_05.png')},
          {label:'行政',key:'xingzhen',icon:require('../images/rsrc/flfw_07.png')},
          {label:'房产',key:'fangchan',icon:require('../images/rsrc/flfw_09.png')},
          {label:'建筑',key:'jianzhu',icon:require('../images/rsrc/flfw_11.png')},
          {label:'婚姻',key:'hunyin',icon:require('../images/rsrc/flfw_18.png')},
          {label:'债务',key:'zhaiwu',icon:require('../images/rsrc/flfw_19.png')},
          {label:'劳动',key:'laodong',icon:require('../images/rsrc/flfw_20.png')},
          {label:'交通',key:'jiaotong',icon:require('../images/rsrc/flfw_21.png')},
          {label:'顾问',key:'guwen',icon:require('../images/rsrc/flfw_22.png')},
          {label:'医疗',key:'yiliao',icon:require('../images/rsrc/flfw_23.png')},
          {label:'经济',key:'jingji',icon:require('../images/rsrc/flfw_30.png')},
          {label:'合同',key:'hetong',icon:require('../images/rsrc/flfw_31.png')},
          {label:'大案',key:'daan',icon:require('../images/rsrc/flfw_32.png')},
          {label:'涉外',key:'shewai',icon:require('../images/rsrc/flfw_33.png')},
          {label:'不限',key:'all',icon:require('../images/rsrc/flfw_34.png')},
          {label:'不限',key:'all',icon:require('../images/rsrc/flfw_36.png')},
        ],
      },
      list_nav6: {
        bannerData: [],
        listData: [
          {name:'在线访谈',key:'interview',num:10,data:[]},
          // {name:'访谈预告',key:'interviewNotice',num:4,data:[]},
          // {name:'访谈录播',key:'interviewRecording',num:4,data:[]},
          {name:'百事通',key:'knowAll',num:7,data:[]},
        ]
      },
      list_nav7: {
        bannerData:[],
        listData: [
          {name:'新闻中心',key:'newsCenter',num:11,data:[]},
        ],
      },
    }
  },
  computed: {
    ...mapState(['siteNavs_x']),
  },
  watch: {
    pageAreaId_x(val) {
      // this.init()
      // this.tabChange(this.nav_sub_ac)
      this.$refs.tab.handleTabClick(this.nav_sub_ac, String(this.nav_sub_ac))
      const mapList = [
        'list_nav0',
        'list_nav1',
        'list_nav2',
        'list_nav3',
        'list_nav6',
        'list_nav7',
      ]
      mapList.forEach(x => {
        this[x].listData.forEach(x2 => {
          x2.data = []
        })
      })
      this.getBannerData('banner_rs', 0)
      this.getBannerData('banner_xw', 7)
    },
  },
  methods: {
    tabChange(index) {
      console.log(index)
      if (typeof index === 'number') {
        switch (index) {
          case 0: case 1: case 6: case 7:
            if (this['list_nav' + this.nav_ac].listData[0].data.length === 0) {
              this.getData()
            }
            break;
          case 2: case 3:
            if (this['list_nav' + this.nav_ac].listData[0].data.length === 0) {
              this.getData2()
            }
        }
      } else {
        console.log('点击了', index.label)
      }
    },

    openUrl(url) {
      if (url) {
        if (url.indexOf('http') !== 0) {
          url = 'http://' + url
        }
        url && window.open(url)
      }
    },

    navTo(key, key2) {
      // console.log(key, key2)
      if (key === 'out') {
        window.open('http://www.chinaexpertnet.com.cn/')
      } else {
        let url = `/fuwu?areaId=${this.pageAreaId_x}&type=${key}&page=1`
        key2 ? url += `&f=${key2}` : ''
        this.$router.push(url)
      }
    },
    navTo3g48(key) {
      this.$router.push(`/fuwu?areaId=${this.pageAreaId_x}&type=${key}&page=1`)
    },
    navTo3g48Detail(key, item) {
      console.log(item)
      let { o_name, organizationName, id } = item
      if (key === 'zhaopin') {
        this.$router.push(`/recruitDetail?type=zhaopin&id=${id}`)
      } else { 
        this.$router.push(`/detail?areaId=${this.pageAreaId_x}&type=${key}&oname=${o_name||organizationName}&id=${id}`)
      }
    },
    navToRsrc(key) {
      this.$router.push(`/renshiNav?areaId=${this.pageAreaId_x}&catalog=${key}&page=1`)
    },
    navToRsrcDetail(item) {
      console.log(item)
      if (item.outUrl) {
        window.open (item.outUrl)
      } else {
        let { catalog, id } = item
        this.$router.push(`/renshiNav?areaId=${this.pageAreaId_x}&catalog=${catalog}&id=${id}`)
      }
    },
    navToRsrc(catalog) {
      this.$router.push(`/renshiNav?areaId=${this.pageAreaId_x}&catalog=${catalog}&page=1`)
    },
    navToOut(url) {
      if (!~url.indexOf('http')) {
        url = 'http://' + url
      }
      window.open(url)
    },

    getData() {
      this['list_nav' + this.nav_ac].listData.forEach(x =>{
        let catalog = x.key
        let pageSize = x.num
        let rD = { catalog, pageSize, areaId: this.pageAreaId_x }
        rD.includeParentSite = true
        this.$api.util_search('xinwen', rD).then(res =>{
          if (res.data.status === 0) {
            let _R = JSON.parse(res.data.data)
            x.data = _R
          } else{ this._status(res.data) }
        })
      })
    },
    getData2() {
      this['list_nav' + this.nav_ac].listData.forEach(x =>{
        let pageSize = x.num
        let rD = { pageSize, areaId: this.pageAreaId_x }
        this.$api.util_search(x.key, rD).then(res =>{
          if (res.data.status === 0) {
            let _R = JSON.parse(res.data.data)
            console.log(_R)
            x.data = _R
          } else{ this._status(res.data) }
        })
      })
    },
    getBannerData(carouselType, index) {
      let rD = { carouselType, online: true, areaId: this.pageAreaId_x, pageSize: 10 }
      rD.includeParentSite = true
      this.$api.util_search('banner', rD).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          // console.log(_R)
          this['list_nav' + index].bannerData =_R
        } else { this._status(res.data) }
      })
    },

    init() {
      this.getData()
      this.getBannerData('banner_rs', 0)
      this.getBannerData('banner_xw', 7)
    },
  },
  created() {
    this.init()
  },
  mounted() {
    this.$nextTick(() => {
      let tabs = document.getElementsByClassName('el-tabs__item')
      for (let i = 0 ; i < tabs.length ; i++) {
        tabs[i].addEventListener('mouseover', e => {
          this.$refs.tab.handleTabClick(i, String(i))
          // this.$refs.tab.handleTabClick(i)
        })
      }
    })
  },
}
</script>

<style lang='scss' scoped>
/deep/.el-tabs--border-card{background-color:transparent;box-shadow:none;-webkit-box-shadow:none;}
/deep/.el-tabs__header.is-left{margin: 0px;border-right:none;background-color:transparent;}
/deep/.el-tabs__content{padding: 0px;height: 100%;}
/deep/.el-tab-pane{height: 100%;}
/deep/.el-tabs__nav.is-left{height: 100%;}
/deep/.el-tabs__item.is-left{
  width: 75px;height: 12.5%;line-height: 20px;text-align: center;
  color: #fff;white-space: normal;font-weight: bold;
  padding: 6px 18px;margin: 0!important;text-shadow: 2px 2px 2px #333;box-sizing: border-box;
}
/deep/.el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover,
/deep/.el-tabs__item.is-left.is-active{
  color: #333;text-shadow: none;background-color: #fff;border-bottom: 2px solid #ef0022!important;
}
.nav_sub{font-size: 18px;}

.renshiindex{
  padding: 50px 0px 50px;
  background: url('../images/renshibg.jpg') no-repeat #9AD3FF;
  background-size: cover;
  .bigbox{align-items:stretch;}
  .bigbox .contbox{height: 420px;border: none;}
  .bigbox .datainfo{width: 1100px;height: 420px;}
}

.nav-banner{
  height: 420px;
  .bannerbox{
    height: 100%;width: 650px;
    .el-carousel.el-carousel--horizontal{height: 100%;}
    .bannerImg{width: 100%;height: 100%;cursor: pointer;}
  }
  .showDatabox{
    width: 420px;font-size: 14px;padding: 10px 15px 0 15px;height: 100%;background-color: #fff;
    .cataloglist{
      width: 100%;height: 34px;margin-top: 10px;
      li{
        width: 26%;height: 32px;line-height: 32px;text-align: center;
        padding-bottom: 2px;color: #333;cursor: pointer;border-bottom: 2px solid #cfdae2;
        &.active{font-weight: 600;border-color: #ef0022;}
      }
    }
    .articleul{margin-top: 10px;}
    .articlelist{
      height: 32px;line-height: 32px;cursor: pointer;
      .dian{
        display: inline-block;width: 5px;height: 5px;
        margin-right: 5px;border-radius: 50%;background: #000;
      }
      .titlespan{
        display: inline-block;width: 310px;margin-right: 30px;
        overflow: hidden;text-overflow:ellipsis;white-space: nowrap;
      }
      .timespan{
        display: inline-block;width: 80px;height: 32px;line-height: 32px;font-size: 12px;color: #999;
      }
    }
  }
}
li:hover,
li:hover span{color: #ef0022!important;}
li:hover span.dian{color: #ef0022!important;background: #ef0022!important;}

.flex-l{align-items: flex-start;flex-wrap: wrap;flex-direction: column;}
.flex-h{
  align-items: flex-start;flex-wrap: wrap;justify-content: space-around;
  padding: 40px;box-sizing: border-box;
  background: url('../images/rsrc/flfw_bg.jpg') no-repeat 100% 100%;
}
.nav-normal{
  height: 100%;background-color: #fff;
  &.part-3 .renshicont{
    &:nth-child(1){height: 95%;margin: 0px;}
    &:nth-child(2){flex: 1;margin: 0px;}
  }
  &.part-rccs .renshicont{
    &:nth-child(1){height: 70%;margin: 0px;}
    &.btn-box{position: absolute;left: 0;bottom: 0;}
  }
  &.part-hdjl .renshicont{
    &:nth-child(1){height: 95%;margin: 0px;}
    &:nth-child(2){flex: 1;margin: 0px;}
  }
  .renshicont{
    width: calc(50% - 30px);height: calc(50% - 20px);padding: 10px 15px;
    ul{
      height: 100%;
      li{line-height: 32px;height: 32px;font-size: 14px;color: #333;}
      .listcatalog{
        height: 36px;line-height: 36px;padding: 0px;margin-bottom: 10px;
        border-bottom: 2px solid #e1e1e1;position: relative;
        .name{display: inline-block;font-weight: 600;border-bottom: 2px solid #ef0022;cursor: pointer;}
        .more{position: absolute;right: 20px;cursor: pointer;}
      }
      .list{
        position: relative;cursor: pointer;border-bottom: 1px dashed #999;
        .titlespan{
          display: inline-block;width: 320px;margin-right: 30px;
          overflow: hidden;text-overflow:ellipsis;white-space: nowrap;
        }
        .timespan{position: absolute;right: 10px;}
      }
    }
  }
}

.icon-btn{width: 16%;height: 100px;text-align: center;box-sizing: border-box;padding: 10px 30px;}
.icon-btn1{width: 22%;height: 70px;background: #f2f2f2;}
.icon-btn1 p{font-size: 24px;color: #666;}

.btn-box{
  justify-content: center;height: 100px!important;
  .btn{background: #4283cc;width: 340px;justify-content: center;cursor: pointer;}
  p{color: #ffee10;font-size: 30px;font-weight: bold;margin-left: 20px;}
}

.outBox{padding-left: 75px;box-sizing: border-box;flex-wrap: wrap;}
// .outBtn{width: 110px;height: 60px;text-align: center;line-height: 60px;cursor: pointer;border-bottom: 2px solid transparent;}
// .outBtn:hover{background: #fff;border-bottom-color: #ef0022;font-weight: bold;}
// .outBtn{width: 110px;height: 60px;text-align: center;line-height: 60px;cursor: pointer;color: #fff;font-size: 18px;}
.outBtn{
  width: 110px;height: 50px;text-align: center;line-height: 50px;
  font-size: 13px;font-weight: bold;color: #fff;text-shadow: 2px 2px 2px #333;
  cursor: pointer;border-bottom: 2px solid transparent;
}
.outBtn:hover{color: #333;text-shadow: none;background: #fff;border-bottom-color: #ef0022;font-weight: bold;}
</style>